<template>
  <div class="report">
    <report-header />
    <report-body />
  </div>
</template>

<script>
import Header from "../components/report/Header";
import Body from "../components/report/Body";

export default {
  components: {
    "report-header": Header,
    "report-body": Body
  }
};
</script>

<style scoped></style>
